import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { formatDateBR } from "@/utils/dateUtils";
import type { DisponibilidadeSummary } from "@/utils/disponibilidadeUtils";

interface AlocacaoChipProps {
  summary?: DisponibilidadeSummary | null;
  className?: string;
}

export function AlocacaoChip({ summary, className }: AlocacaoChipProps) {
  if (!summary || (summary.carga_atual ?? 0) === 0) return null;

  const temFixo = !!summary.tem_projeto_fixo;
  const proximaRenovacao = summary.next_freeing_date;
  if (!temFixo && !proximaRenovacao) return null;

  const texto = temFixo ? "Fixo" : `Até ${formatDateBR(proximaRenovacao, "dd/MM")}`;
  const chip = (
    <span
      className={cn(
        "inline-flex min-w-0 items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] font-medium text-slate-600",
        className,
      )}
    >
      <span className="truncate">{texto}</span>
    </span>
  );

  const tooltip = temFixo
    ? proximaRenovacao
      ? `Tem projeto fixo e outro que renova em ${formatDateBR(proximaRenovacao)}`
      : null
    : `Renova em ${formatDateBR(proximaRenovacao)}`;

  if (!tooltip) return chip;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-default min-w-0">{chip}</span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[240px] text-xs">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default AlocacaoChip;
